import React, { createContext, useContext } from "react";

export const headerThemes = {
    LIGHT: "light",
    DARK: "dark",
    INVISIBLE: "invisible"
};

export const HeaderThemeContext = createContext({
    theme: headerThemes.LIGHT,
    setTheme: () => {}
});

// This is a HOOK and can only be used in a functional component with access to the HeaderThemeContext.
/* eslint-disable-next-line */
export const setHeaderTheme = theme => useContext(HeaderThemeContext).setTheme(theme);

export const PagesContext = createContext({
    slug: '',
    subPages: [],
    subPagesSpecial: []
});

export const BlogArchiveSlugContext = createContext({
    blogSlug: ''
});